import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  IAcademicsMenuCoursesData,
  IAcademicsMenuProgramsData,
} from "../exports/interfaces";
import { useMobile } from "../hooks/custom/useMobile";
import useTab from "../hooks/custom/useTab";
import $ from "jquery";
import { useBrochureContext } from "../context/BrochureContext";

const AcademicsMegaMenu = ({
  closeSidebar,
  openViewer,
  academicsMenuPrograms,
  academicsMenuCourses,
}: {
  closeSidebar: () => void;
  openViewer: (path: string) => void;
  academicsMenuPrograms: IAcademicsMenuProgramsData[]; 
  academicsMenuCourses: IAcademicsMenuCoursesData[];
}) => {
  const mobile = useMobile();
  const tab = useTab();
  const { undergraduateBrochureData, mppBrochureData } = useBrochureContext();

  const programs = academicsMenuPrograms.map((program) => {
    return {
      title: program.title,
      color: program.color_code,
      icon: program.icon_code,
      icon_image: program.icon_image,
      courses: academicsMenuCourses
        .filter((course) => course.program_name === program.title)
        .map((course) => course.name),
    };
  });

  useEffect(() => {
    if (!programs.length) return;

    // remove old toggles (avoid duplicates)
    $(".td_munu_dropdown_toggle").remove();

    // add toggle buttons
    if (mobile || tab) {
      $(".menu-item-has-children").append(
        '<span class="td_munu_dropdown_toggle"><span></span></span>',
      );
    } else {
      $("#sidebar .td_mega_wrapper .menu-item-has-children").append(
        '<span class="td_munu_dropdown_toggle"><span></span></span>',
      );
    }

    // click event
    $(".td_munu_dropdown_toggle")
      .off("click")
      .on("click", function () {
        $(this).toggleClass("active").siblings("ul").slideToggle();
        $(this).parent().toggleClass("active");
      });
  }, [mobile, programs, tab]);

  // const [activeTab, setActiveTab] = useState<string>("td_tab_1");

  // const handleTabClick = (e: React.MouseEvent, hash: string) => {
  //   e.preventDefault();
  //   setActiveTab(hash);
  // };
  return mobile || tab ? (
    <>
      <ul className="td_mega_wrapper">
        {/* <li className="menu-item-has-children"> */}
        <h4
          style={{
            width: "90%",
          }}
        >
          <Link to="/sast" className="p-0">
            School of Arts, Sciences & Technology (SAST)
          </Link>
        </h4>

        {/* <ul className="td_mega_wrapper"> */}
        {/* PROGRAM GROUP (if you have grouping like Undergraduate / Graduate) */}
        <li className="menu-item-has-children">
          <h4
            style={{
              width: "90%",
              padding: "12px 30px",
            }}
          >
            Undergraduate Programs
          </h4>

          <ul className="td_mega_wrapper">
            {programs.map((program, index) => (
              <li key={index} className="menu-item-has-children">
                {/* PROGRAM TITLE */}
                <h4
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    width: "90%",
                    padding: "12px 30px",
                  }}
                >
                  {program.icon_image ? (
                    <img
                      src={`${process.env.REACT_APP_cmsUrl}${program?.icon_image?.[0]?.media?.url}`}
                      alt={program.title}
                      className="d-block"
                      style={{
                        width: "20px",
                        height: "20px",
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    <i className={program.icon}></i>
                  )}

                  {program.title}
                </h4>
                {/* COURSES */}
                <ul>
                  {program.courses?.map((course, i) => (
                    <li key={i}>
                      <Link
                        to={`/sast/${program.title}/${course}`}
                        onClick={closeSidebar}
                        style={{ paddingLeft: "60px" }}
                      >
                        {course}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        </li>
        <Link
          to="#"
          className="ms-3"
          onClick={() => {
            closeSidebar();
            openViewer(
              undergraduateBrochureData[0]?.file && undergraduateBrochureData[0]?.file.length > 0
                ? undergraduateBrochureData[0]?.file[0]?.media?.url
                : undergraduateBrochureData[0]?.link,
            );
          }}
        >
          Undergraduate Brochure
        </Link>
        {/* </ul> */}
        {/* </li> */}
        {/* <li className="menu-item-has-children"> */}
        <h4
          style={{
            width: "90%",
          }}
        >
          School of Public Policy (SPP)
        </h4>
        {/* <ul className="td_mega_wrapper"> */}
        <li className="menu-item-has-children">
          <h4
            style={{
              width: "90%",
              padding: "12px 30px",
            }}
          >
            Graduate Programs
          </h4>
          <ul>
            <li>
              <Link
                to="/mpp"
                onClick={() => {
                  closeSidebar();
                }}
                style={{ paddingLeft: "60px" }}
              >
                Master of Public Policy (MPP)
              </Link>
            </li>
          </ul>
        </li>
        <Link
          to="#"
          className="ms-3"
          onClick={() => {
            closeSidebar();
            openViewer(
              mppBrochureData[0]?.file && mppBrochureData[0]?.file.length > 0
                ? mppBrochureData[0]?.file[0]?.media?.url
                : mppBrochureData[0]?.link,
            );
          }}
        >
          MPP Brochure
        </Link>
      </ul>
      {/* </li> */}
      {/* </ul> */}
    </>
  ) : (
    // <ul className="td_mega_wrapper flex-wrap">
    //   <li className="mega-tab">
    //     <li className={`${activeTab === "td_tab_1" && "active"}`}>
    //       <a href="#td_tab_1" onClick={(e) => handleTabClick(e, "td_tab_1")}>
    //         <h4 className="mb-0">
    //           School of Arts, Sciences & Technology (SAST)
    //         </h4>
    //       </a>
    //     </li>
    //     <li className={`${activeTab === "td_tab_2" && "active"}`}>
    //       <a href="#td_tab_2" onClick={(e) => handleTabClick(e, "td_tab_2")}>
    //         <h4 className="mb-0">School of Public Policy (SPP)</h4>
    //       </a>
    //     </li>
    //   </li>
    //   <>
    //     <li
    //       className={`menu-item-has-children full-flex ${activeTab === "td_tab_1" ? "d-block" : "d-none"}`}
    //     >
    //       <h4>Undergraduate Programs</h4>
    //       <ul>
    //         <li>
    //           {/* <Link
    //             to="/undergraduate"
    //             onClick={() => {
    //               closeSidebar();
    //               setActiveTab("td_tab_1");
    //             }}
    //           >
    //             School of Arts, Sciences & Technology (SAST)
    //           </Link> */}
    //           <div className="program-container">
    //             {programs.map((item, index) => (
    //               <div className="program-card" key={index}>
    //                 <div>
    //                   {/* <div
    //                     className="icon"
    //                     style={{ backgroundColor: item.color }}
    //                   > */}
    //                   {item.icon_image ? (
    //                     <img
    //                       src={`${process.env.REACT_APP_cmsUrl}${item?.icon_image[0]?.media?.url}`}
    //                       alt={item.title}
    //                       style={{
    //                         width: "20px",
    //                         height: "20px",
    //                         objectFit: "contain",
    //                       }}
    //                     />
    //                   ) : (
    //                     <i className={item.icon}></i>
    //                   )}
    //                   {/* </div> */}

    //                   <h6>{item.title}</h6>
    //                 </div>
    //                 <ul>
    //                   {item.courses.map((course, i) => (
    //                     <li key={i}>
    //                       <Link
    //                         to="/"
    //                         onClick={() => {
    //                           closeSidebar();
    //                           setActiveTab("td_tab_1");
    //                         }}
    //                       >
    //                         {course}
    //                       </Link>
    //                     </li>
    //                   ))}
    //                 </ul>
    //               </div>
    //             ))}
    //           </div>
    //         </li>
    //       </ul>
    //     </li>
    //   </>
    //   <li
    //     className={`menu-item-has-children ${activeTab === "td_tab_2" ? "d-block" : "d-none"}`}
    //   >
    //     <h4>Graduate Programs </h4>
    //     <ul>
    //       <li>
    //         <Link
    //           to="/graduate"
    //           onClick={() => {
    //             closeSidebar();
    //             setActiveTab("td_tab_1");
    //           }}
    //         >
    //           Master of Public Policy (MPP)
    //         </Link>
    //       </li>
    //     </ul>
    //   </li>
    // </ul>
    <ul style={{width: '350px'}}>
      <h6>
        <Link to="/sast" className="p-0">
          School of Arts, Sciences & Technology (SAST)
        </Link>
      </h6>
      <li className="menu-item-has-children">
        <Link
          to="#"
          className="ms-3"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          Undergraduate Programs
          <i
            className="fa-solid fa-angle-right"
            style={{ fontSize: "10px" }}
          ></i>
        </Link>
        <ul className="custom-sub-width">
          {programs.map((program, index) => (
            <li key={index} className="menu-item-has-children">
              {/* PROGRAM TITLE */}
              <h6
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                {program.icon_image ? (
                  <img
                    src={`${process.env.REACT_APP_cmsUrl}${program?.icon_image?.[0]?.media?.url}`}
                    alt={program.title}
                    className="d-block"
                    style={{
                      width: "20px",
                      height: "20px",
                      objectFit: "contain",
                    }}
                  />
                ) : (
                  <i className={program.icon}></i>
                )}

                {program.title}
              </h6>

              {/* COURSES */}
              {program.courses?.map((course, i) => (
                <Link
                  to={`/sast/${program.title}/${course}`}
                  onClick={closeSidebar}
                  className="course-sub-menu"
                >
                  {course}
                </Link>
              ))}
            </li>
          ))}
        </ul>
      </li>
      <Link
        to="#"
        className="ms-3"
        onClick={() => {
          openViewer(
            undergraduateBrochureData[0]?.file && undergraduateBrochureData[0]?.file.length > 0
              ? undergraduateBrochureData[0]?.file[0]?.media?.url
              : undergraduateBrochureData[0]?.link,
          );
        }}
      >
        Undergraduate Brochure
      </Link>
      <h6>School of Public Policy (SPP)</h6>
      <li className="menu-item-has-children">
        <Link
          to="#"
          className="ms-3"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          Graduate Programs
          <i
            className="fa-solid fa-angle-right"
            style={{ fontSize: "10px" }}
          ></i>
        </Link>

        <ul>
          <li>
            <Link
              to="/mpp"
              onClick={() => {
                closeSidebar();
              }}
            >
              Master of Public Policy (MPP)
            </Link>
          </li>
        </ul>
      </li>
      <Link
        to="#"
        className="ms-3"
        onClick={() => {
          openViewer(
            mppBrochureData[0]?.file && mppBrochureData[0]?.file.length > 0
              ? mppBrochureData[0]?.file[0]?.media?.url
              : mppBrochureData[0]?.link,
          );
        }}
      >
        MPP Brochure
      </Link>
    </ul>
  );

  // return (
  //   <ul>
  //     <h6>School of Arts, Sciences & Technology (SAST)</h6>
  //     <li className="menu-item-has-children">
  //       <h6 className="ms-">Undergraduate Programs</h6>
  //       <ul>
  //         {programs.map((program, index) => (
  //           <li key={index} className="menu-item-has-children">
  //             {/* PROGRAM TITLE */}
  //             <h6
  //               style={{
  //                 display: "flex",
  //                 alignItems: "center",
  //                 gap: "10px",
  //               }}
  //             >
  //               {program.icon_image ? (
  //                 <img
  //                   src={`${process.env.REACT_APP_cmsUrl}${program?.icon_image?.[0]?.media?.url}`}
  //                   alt={program.title}
  //                   className="d-block"
  //                   style={{
  //                     width: "20px",
  //                     height: "20px",
  //                     objectFit: "contain",
  //                   }}
  //                 />
  //               ) : (
  //                 <i className={program.icon}></i>
  //               )}

  //               {program.title}
  //             </h6>

  //             {/* COURSES */}
  //             <ul>
  //               {program.courses?.map((course, i) => (
  //                 <li key={i}>
  //                   <Link
  //                     to="/"
  //                     onClick={closeSidebar}
  //                     style={{
  //                       marginLeft: "30px",
  //                     }}
  //                   >
  //                     {course}
  //                   </Link>
  //                 </li>
  //               ))}
  //             </ul>
  //           </li>
  //         ))}
  //       </ul>
  //     </li>
  //     <li className="menu-item-has-children">
  //       <h6>School of Public Policy (SPP)</h6>
  //       <ul>
  //         <li className="menu-item-has-children">
  //           <h6>Graduate Programs</h6>
  //           <ul>
  //             <li>
  //               <Link
  //                 to="/graduate"
  //                 onClick={() => {
  //                   closeSidebar();
  //                 }}
  //               >
  //                 Master of Public Policy (MPP)
  //               </Link>
  //             </li>
  //           </ul>
  //         </li>
  //       </ul>
  //     </li>
  //   </ul>
  // );
};

export default AcademicsMegaMenu;
